





















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import SurveyService from '@/services/SurveyService'
import SurveyHelper from '@/utils/SurveyHelper'
import SurveyLocalStorageHelper from '@/utils/SurveyLocalStorageHelper'
import { SurveyInfo } from '@/interfaces/SurveyInterfaces'
import { MainLogosTypes } from '@/interfaces/GeneralInterfaces'

@Component({ name: 'DpChildSurveyCompletedPage' })
export default class DpChildSurveyCompletedPage extends Vue {
  @Prop({})
  surveyProduct!: string
  @Prop({})
  surveyUserId!: string

  @Getter('survey/isTakenSurveyInitiated')
  isTakenSurveyInitiated!: boolean

  @Getter('survey/isDpTakenSurvey')
  isDpTakenSurvey!: boolean
  @Getter('survey/getDpSurveyUserId')
  dpSurveyUserId!: number

  @Getter('survey/getDisplayedBaseSurveyInfo')
  surveyInfo!: SurveyInfo

  partCompleted = 0

  async created (): Promise<void> {
    if (!this.isTakenSurveyInitiated &&
      SurveyLocalStorageHelper.hasSurveyUser(this.surveyProduct, parseInt(this.surveyUserId)) &&
      !await SurveyHelper.uploadDpSurveyDataByChild(
        SurveyLocalStorageHelper.getSurveyUser(this.surveyProduct, parseInt(this.surveyUserId))
      )
    ) {
      SurveyLocalStorageHelper.removeSurveyUser(this.surveyProduct, parseInt(this.surveyUserId))
    }

    if (!this.isDpTakenSurvey) {
      this.$router.push({ name: 'notFound' })
      return
    }

    this.$store.commit('mainLogo/setLogos', this.$store.getters['survey/getDpSurveyLogo'])

    this.partCompleted = this.surveyProduct === 'eq' ? 1
      : this.surveyProduct === 'values' ? 2
        : this.surveyProduct === 'behaviours' ? 3
          : 0
  }

  async nextDpPart (): Promise<void> {
    const progress = await SurveyService.getDpSurveyProgress(this.dpSurveyUserId)

    if (progress.isCompleted || !progress.nextSurveyPart) {
      SurveyHelper.completeSurvey(
        'discovery-process',
        await this.$store.getters['survey/getDpSurveyId'],
        this.dpSurveyUserId
      )

      this.$store.commit('survey/clearDpSurveyData')
      this.$router.push({ name: 'survey.complete', params: { title: this.surveyInfo.title } })
      return
    }

    const nextSurveyProductInfo = await SurveyService.getSurveyInfoById(
      progress.nextSurveyPart.product,
      progress.nextSurveyPart.id
    )

    await this.$store.commit('survey/setTakenSurveyData', {
      productSurveyId: progress.nextSurveyPart.id,
      productSurveyType: progress.nextSurveyPart.product,
      surveyInfo: nextSurveyProductInfo
    })

    this.$store.commit('mainLogo/setLogos', nextSurveyProductInfo.logos)
    this.$store.commit('mainLogo/setType', MainLogosTypes.SURVEY_LOGOS)

    await this.$store.commit('survey/setTakenSurveyUserId', {
      productSurveyType: progress.nextSurveyPart.product,
      surveyUserId: progress.nextSurveyPart.surveyUserId
    })

    SurveyLocalStorageHelper.addDpChildSurveyUser(
      this.dpSurveyUserId,
      progress.nextSurveyPart.product,
      progress.nextSurveyPart.surveyUserId
    )

    this.$router.push({
      name: 'survey.welcome.dp.survey_product',
      params: {
        surveyProduct: progress.nextSurveyPart.product,
        surveyUserId: progress.nextSurveyPart.surveyUserId.toString()
      }
    })
  }
}
